import type { FilterData } from 'portlet/models';
import {
    areDatabricksQueryParameters,
    type DatabricksQueryTable,
} from 'portlet/models/query/systems/databricks/types';
import type { PortletQueryParams } from 'portlet/models/query/systems/types';

import type { QueryReplacer } from '.';
import { getColumnValue } from './utils';

// Searches for {filtervalue(column1)} in query statement and applies proper
// column value into it based on dispatched filters (when column has no default value or assigned filter is not dispatched - return NULL)
// eg.
// For filters: COMPANY: Bayer
// filtervalue(column1) => 'Bayer'
// filtervalue(column2) => NULL
export const FilterValueQueryReplacer: QueryReplacer = {
    regex: /\{filtervalue\(([\w.]+)\)\}/,
    replace: (statement, tables, filterValues, regexMatches) => {
        if (
            !tables.length ||
            !regexMatches.length ||
            !regexMatches.every(item => item.group.length === 1)
        ) {
            return statement;
        }

        return regexMatches.reduce((pre, cur) => {
            const columnName = cur.group[0];

            return pre.replace(cur.exact, getFilterValue(columnName, tables, filterValues));
        }, statement);
    },
};

// Works same as FilterValueQueryReplacer but as a vega expression
export const ac_sqlDbxFormatFilter = (query: PortletQueryParams, column: string): string => {
    if (!areDatabricksQueryParameters(query)) {
        return 'NULL';
    }

    return getFilterValue(column, query.metadata.tables, query.filters);
};

function getFilterValue(
    columnName: string,
    tables: DatabricksQueryTable[],
    filterValues: FilterData[],
): string {
    const NULL = 'NULL';
    const tableColumn = tables
        .map(table =>
            table.columns.map(col => ({
                ...col,
                tableName: `${table.name}.${col.name}`,
            })),
        )
        .flat()
        .find(item => item.name === columnName || item.tableName === columnName);

    if (!tableColumn) {
        return NULL;
    }
    const columnValue = getColumnValue(tableColumn, filterValues);

    return columnValue.value ?? NULL;
}
